"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedTextEditorWidget = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("@rjsf/utils");
const formatted_text_editor_1 = require("@squiz/formatted-text-editor");
const FormattedTextEditorWidget = ({ disabled, formData, onChange, idSchema }) => {
    const transformedContent = (0, formatted_text_editor_1.squizNodeToRemirrorNode)(formData instanceof Array ? formData : []);
    const attributes = {
        id: idSchema.$id,
        name: idSchema.$id,
        'aria-describedby': (0, utils_1.ariaDescribedByIds)(idSchema),
        'aria-labelledby': (0, utils_1.titleId)(idSchema),
    };
    const handleChange = (parameter) => {
        if (parameter.tr?.docChanged) {
            onChange((0, formatted_text_editor_1.remirrorNodeToSquizNode)(parameter.state.doc));
        }
    };
    return react_1.default.createElement(formatted_text_editor_1.Editor, { content: transformedContent, editable: !disabled, onChange: handleChange, attributes: attributes });
};
exports.FormattedTextEditorWidget = FormattedTextEditorWidget;
